import { Component, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterLink } from '@angular/router';
import { CommonIconTextWidget } from '@eforall/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
// import { SearchWidget } from '../../../../ui/widget';
import { DashboardMenuService } from '../../../services';
import { DashboardFrameService } from '../../dashboard-frame.service';
import { DevBannerPart } from '../menu/dev-banner.part';


@Component({
	selector: 'frame-navbar',
	standalone: true,
	imports: [
		MatMenuModule,
		RouterLink,
		DevBannerPart,
		NgbDropdownModule,
		CommonIconTextWidget,
	],
	templateUrl: './navbar.part.html',
	styleUrls: ['./navbar.part.scss']
})
export class NavbarPart {

	public router = inject(Router);
	public menu = inject(DashboardMenuService);
	public frameService = inject(DashboardFrameService);

}